import type { ChatUIMessage } from "./types/chat-ui-message";

export interface PrepareChatSendRequestOptions {
  id?: string;
  messages?: ChatUIMessage[];
  trigger?: "submit-message" | "regenerate-message";
  messageId?: string;
  headers?: HeadersInit;
  body?: Record<string, unknown>;
}

export interface PrepareChatSendRequestInput {
  token: string;
  debugTraceEnabled: boolean;
  options: PrepareChatSendRequestOptions;
}

export interface PreparedChatSendRequest {
  headers: Record<string, string>;
  body: Record<string, unknown>;
}

export function prepareChatSendRequest({
  token,
  debugTraceEnabled,
  options
}: PrepareChatSendRequestInput): PreparedChatSendRequest {
  const headers = new Headers(options.headers);
  headers.set("Authorization", `Bearer ${token}`);

  if (debugTraceEnabled) {
    headers.set("x-agent-debug-trace", "1");
  }

  const body: Record<string, unknown> = {
    ...(options.body ?? {})
  };

  if (options.id !== undefined) {
    body.id = options.id;
  }

  if (options.messages !== undefined) {
    body.messages = options.messages;
  }

  if (options.trigger !== undefined) {
    body.trigger = options.trigger;
  }

  if (options.messageId !== undefined) {
    body.messageId = options.messageId;
  }

  const plainHeaders: Record<string, string> = {};
  headers.forEach((value, key) => {
    plainHeaders[key] = value;
  });

  return {
    headers: plainHeaders,
    body
  };
}
